// extracted by mini-css-extract-plugin
export var quillEditor = "_pz-1";
export var variable = "_pz-0";